import getLogger from '@signal/core/fe-logging'
import {
  AccountGuidError,
  AuthError,
  UnauthorizedError,
  RequestTimeoutError
} from '@signal/utils/errors'
import LngLatMapError from '@signal/utils/errors/LngLatMapError'

// the global exception handler below will log any and all exceptions, but some
// kinds of exceptions are expected and not something we want to log to the BE
const IGNORE_EXCEPTION_CLASSES = [
  AccountGuidError,
  AuthError,
  LngLatMapError,
  UnauthorizedError,
  RequestTimeoutError
]
const IGNORE_EXCEPTION_MESSAGES = ['Missing data for this widget']

/*
 * logExceptionIfNotIgnored - sends exception logging if this exception is not ignored
 * @param {Error} - the exception to log
 */
function logExceptionIfNotIgnored(error: Error) {
  if (
    !IGNORE_EXCEPTION_CLASSES.some(cls => error instanceof cls) &&
    !IGNORE_EXCEPTION_MESSAGES.some(ignore => error.message.includes(ignore))
  ) {
    getLogger().exception(error)
  }
}

/*
 * hookGlobalExceptionLogging - hook up global exception logging
 */
export function hookGlobalExceptionLogging() {
  window.addEventListener('error', evt => {
    logExceptionIfNotIgnored(evt.error)
  })

  window.addEventListener('unhandledrejection', evt => {
    logExceptionIfNotIgnored(evt.reason)
  })
}
